const styles = {
    button: {
        fontSize: '0.625rem',
    },
    divider: {
        mb: {xs: '0.5rem', md: '1rem'}
    },
    bottomContainer: {
        border: '1px solid black',
        padding: '0.625rem',
        transition: '1s',
        backgroundColor: 'gainsboro',
        mt: {xs: '1rem', md: '2rem'}
    }
}

export default styles;